/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIPartEstimatedPriceRequest
 */
export interface APIPartEstimatedPriceRequest {
    /**
     * 
     * @type {string}
     * @memberof APIPartEstimatedPriceRequest
     */
    estimatedPrice?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPartEstimatedPriceRequest
     */
    estimatedInvestmentCost?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPartEstimatedPriceRequest
     */
    estimatedMaterialCost?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPartEstimatedPriceRequest
     */
    estimatedManufacturingCost?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPartEstimatedPriceRequest
     */
    estimatedTreatmentCost?: string;
}

/**
 * Check if a given object implements the APIPartEstimatedPriceRequest interface.
 */
export function instanceOfAPIPartEstimatedPriceRequest(value: object): value is APIPartEstimatedPriceRequest {
    return true;
}

export function APIPartEstimatedPriceRequestFromJSON(json: any): APIPartEstimatedPriceRequest {
    return APIPartEstimatedPriceRequestFromJSONTyped(json, false);
}

export function APIPartEstimatedPriceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPartEstimatedPriceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'estimatedPrice': json['estimated_price'] == null ? undefined : json['estimated_price'],
        'estimatedInvestmentCost': json['estimated_investment_cost'] == null ? undefined : json['estimated_investment_cost'],
        'estimatedMaterialCost': json['estimated_material_cost'] == null ? undefined : json['estimated_material_cost'],
        'estimatedManufacturingCost': json['estimated_manufacturing_cost'] == null ? undefined : json['estimated_manufacturing_cost'],
        'estimatedTreatmentCost': json['estimated_treatment_cost'] == null ? undefined : json['estimated_treatment_cost'],
    };
}

export function APIPartEstimatedPriceRequestToJSON(value?: APIPartEstimatedPriceRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'estimated_price': value['estimatedPrice'],
        'estimated_investment_cost': value['estimatedInvestmentCost'],
        'estimated_material_cost': value['estimatedMaterialCost'],
        'estimated_manufacturing_cost': value['estimatedManufacturingCost'],
        'estimated_treatment_cost': value['estimatedTreatmentCost'],
    };
}

